// Featured items on the collection grid (grid tiles experiment): a card that
// spans several tiles and scrolls through its product's photographs
// (snippets/card-product.liquid, card-tile.liquid; the strip's CSS is in
// sections/main-collection-product-grid.liquid).
//
// The arrows step one photograph at a time and show only when there is more
// that way. Like the product gallery's, each is white over a dark photograph
// and black over a light one: every photograph is read once into a coarse
// brightness profile across its width, and an arrow looks up the column under
// it. The strip lies over the card's link so it can be scrolled; a tap on a
// photograph follows the link (a swipe does not). An item with a description
// card is sized to a regular card's full height (measure). Cards a filter
// brings in are picked up as they arrive.
(function () {
  if (window.cardTilesReady) return;
  window.cardTilesReady = true;

  var STRIP = '.grid__item--featured .card__media';
  var COLUMNS = 12;

  function arrowsOf(strip) {
    var box = strip.parentElement.querySelector('.card-tiles__arrows');
    return box ? { prev: box.querySelector('.card-tiles__arrow--prev'), next: box.querySelector('.card-tiles__arrow--next') } : null;
  }

  function profile(img) {
    if (img._brightness !== undefined) return img._brightness;
    if (!img.complete || !img.naturalWidth) return null;
    try {
      var canvas = document.createElement('canvas');
      canvas.width = COLUMNS;
      canvas.height = 8;
      var ctx = canvas.getContext('2d', { willReadFrequently: true });
      // The middle band of the photograph, where the arrows sit.
      ctx.drawImage(img, 0, img.naturalHeight * 0.35, img.naturalWidth, img.naturalHeight * 0.3, 0, 0, COLUMNS, 8);
      var data = ctx.getImageData(0, 0, COLUMNS, 8).data;
      var columns = [];
      for (var x = 0; x < COLUMNS; x++) {
        var sum = 0;
        for (var y = 0; y < 8; y++) {
          var i = (y * COLUMNS + x) * 4;
          sum += (0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2]) / 255;
        }
        columns.push(sum / 8);
      }
      img._brightness = columns;
    } catch (e) {
      img._brightness = null;
    }
    return img._brightness;
  }

  function tint(strip, arrow) {
    var box = arrow.getBoundingClientRect();
    var x = box.left + box.width / 2;
    // A description card lying on the photographs (the grid's CSS sets
    // --description-overlay): white, so an arrow over it is black.
    var card = strip.parentElement.querySelector('.card-tiles__description');
    if (card && getComputedStyle(card).getPropertyValue('--description-overlay').trim() === '1') {
      var c = card.getBoundingClientRect();
      var y = box.top + box.height / 2;
      if (x >= c.left && x <= c.right && y >= c.top && y <= c.bottom) {
        arrow.classList.add('is-on-light');
        return;
      }
    }
    var tiles = strip.querySelectorAll(':scope > .media');
    for (var t = 0; t < tiles.length; t++) {
      var r = tiles[t].getBoundingClientRect();
      if (x < r.left || x > r.right) continue;
      // An explainer card: white, so the arrow is black -- unless the card is
      // lying on the photograph before it (below three columns), where the
      // photograph is what the arrow sits over.
      if (tiles[t].classList.contains('card-tile--explainer')) {
        if (getComputedStyle(tiles[t]).getPropertyValue('--explainer-overlay').trim() === '1') continue;
        arrow.classList.add('is-on-light');
        return;
      }
      var img = tiles[t].querySelector('img');
      var columns = img && profile(img);
      if (!columns) return;
      var column = Math.min(COLUMNS - 1, Math.max(0, Math.floor(((x - r.left) / r.width) * COLUMNS)));
      arrow.classList.toggle('is-on-light', columns[column] > 0.62);
      return;
    }
  }

  function update(strip) {
    var arrows = arrowsOf(strip);
    if (!arrows) return;
    var max = strip.scrollWidth - strip.clientWidth;
    arrows.prev.disabled = strip.scrollLeft <= 2;
    arrows.next.disabled = strip.scrollLeft >= max - 2;
    tint(strip, arrows.prev);
    tint(strip, arrows.next);
  }

  var pending = new Set();
  var frame = 0;
  function schedule(strip) {
    pending.add(strip);
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      pending.forEach(update);
      pending.clear();
    });
  }

  function setUp(strip) {
    if (strip._tiles) return;
    strip._tiles = true;
    // How many photographs there are: fewer than the row has room for, and
    // the CSS widens them to fill it.
    strip.style.setProperty('--tiles-count', strip.querySelectorAll(':scope > .media').length);
    strip.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { schedule(strip); }, { once: true });
    });
    schedule(strip);
  }

  // A featured item with a description card has no line under its
  // photographs; it grows by that line's height instead, measured here from a
  // regular card of the same grid (the CSS falls back to 4.2rem). A
  // description too long for its card is marked, and fades out where it stops.
  function measure() {
    document.querySelectorAll('.product-grid').forEach(function (grid) {
      // The first regular card on show (a featured item's regular card is
      // hidden in the layouts that feature it).
      var cards = grid.querySelectorAll('.card > .card__content');
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].closest('.grid__item--featured')) continue;
        var height = cards[i].getBoundingClientRect().height;
        if (height > 0) {
          grid.style.setProperty('--card-info-height', height + 'px');
          break;
        }
      }
    });
    document.querySelectorAll('.card-tiles__text').forEach(function (text) {
      text.classList.toggle('is-clipped', text.scrollHeight > text.clientHeight + 1);
    });
  }

  // An explainer card that is to lie on the photograph before it (the grid's
  // CSS sets --explainer-overlay below three columns): as wide as that
  // photograph and pulled back over it, so the card sits on its right side and
  // the strip does not count it as a stop of its own.
  function overlayCards() {
    document.querySelectorAll('.card-tile--explainer').forEach(function (tile) {
      var prev = tile.previousElementSibling;
      var on = getComputedStyle(tile).getPropertyValue('--explainer-overlay').trim() === '1' && prev;
      if (!on) {
        tile.style.removeProperty('margin-left');
        tile.style.removeProperty('flex');
        tile.style.removeProperty('width');
        return;
      }
      var w = prev.getBoundingClientRect().width;
      tile.style.setProperty('flex', '0 0 ' + w + 'px', 'important');
      tile.style.setProperty('width', w + 'px', 'important');
      tile.style.setProperty('margin-left', -w + 'px', 'important');
    });
  }

  function setUpAll() {
    document.querySelectorAll(STRIP).forEach(setUp);
    measure();
    overlayCards();
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest && event.target.closest('.card-tiles__arrow');
    if (arrow) {
      event.preventDefault();
      event.stopPropagation();
      var strip = arrow.closest('.card__inner').querySelector('.card__media');
      var tile = strip.querySelector(':scope > .media');
      var step = tile ? tile.getBoundingClientRect().width : strip.clientWidth;
      strip.scrollBy({ left: arrow.classList.contains('card-tiles__arrow--prev') ? -step : step, behavior: 'smooth' });
      return;
    }
    var photos = event.target.closest && event.target.closest(STRIP);
    if (!photos) return;
    var link = photos.closest('.card-wrapper').querySelector('a[href*="/products/"]');
    if (!link) return;
    event.preventDefault();
    if (event.metaKey || event.ctrlKey) window.open(link.href, '_blank');
    else window.location.href = link.href;
  });

  // Scroll events do not bubble; caught on the way down instead.
  document.addEventListener('scroll', function (event) {
    var strip = event.target;
    if (strip && strip.matches && strip.matches(STRIP)) schedule(strip);
  }, true);

  window.addEventListener('resize', function () {
    document.querySelectorAll(STRIP).forEach(schedule);
    measure();
    overlayCards();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setUpAll);
  else setUpAll();

  // Filtering and sorting replace the grid's contents.
  var setUpFrame = 0;
  function watch() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (setUpFrame) return;
      setUpFrame = requestAnimationFrame(function () {
        setUpFrame = 0;
        setUpAll();
      });
    }).observe(grid, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
